import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor() { }
  getDDMMYYYYfromEPOC(value) {
    const date = new Date(value);
    let d = date.getDate().toString();
    let m = (date.getMonth() + 1).toString();
    const y = date.getFullYear().toString();
    if (d.length === 1) {
      d = '0' + d;
    }
    if (m.length === 1) {
      m = '0' + m;
    }
    return d + '/' + m + '/' + y;
  }

  getNextDate(dt, days) {
    const date = new Date(dt);
    date.setDate(date.getDate() + 1);
    return date.getTime();
  }

  getCurrentDateTime() {
    const vm = this;
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
  }

  getDDMMYYYYHHMMfromEPOC(value) {
    const date = new Date(value);
    let d = date.getDate().toString();
    let m = (date.getMonth() + 1).toString();
    const y = date.getFullYear().toString();
    let hh = date.getHours().toString();
    let mm = date.getMinutes().toString();
    if (d.length === 1) {
      d = '0' + d;
    }
    if (m.length === 1) {
      m = '0' + m;
    }
    if (hh.length === 1) {
      hh = '0' + hh;
    }
    if (mm.length === 1) {
      mm = '0' + mm;
    }
    return d + '/' + m + '/' + y + ' ' + hh + ':' + mm;
  }
}
